import React, { useState, useEffect } from 'react';

function blobToDataURL(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

function Paint({ onClose, isFocus, imageUrl }) {
  const [dataUrl, setDataUrl] = useState(null);

  useEffect(() => {
    if (!imageUrl) {
      setDataUrl(null);
      return;
    }
    const base = imageUrl.startsWith('http')
      ? imageUrl
      : `${window.location.origin}${imageUrl}`;
    const fullUrl = `${base}?v=${Date.now()}`;

    fetch(fullUrl, { cache: 'no-store' })
      .then(r => r.blob())
      .then(blobToDataURL)
      .then(setDataUrl)
      .catch(() => setDataUrl(null));
  }, [imageUrl]);

  const src = dataUrl
    ? `https://jspaint.app/#load:${encodeURIComponent(dataUrl)}`
    : 'https://jspaint.app';

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        position: 'relative',
      }}
    >
      <iframe
        src={src}
        frameBorder="0"
        title="paint"
        style={{
          display: 'block',
          width: '100%',
          height: '100%',
          backgroundColor: 'rgb(192,192,192)',
        }}
      />
      {!isFocus && (
        <div
          style={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            left: 0,
            top: 0,
          }}
        />
      )}
    </div>
  );
}

export default Paint;
